import { FaEnvelope } from "react-icons/fa";

export default function Footer() {
  return (
    <div className="footer">
      <h2>
        Thanks for stopping by! I’m open to full-time product design
        opportunities and 3D freelance work.
      </h2>
      <div className="reachout">
        <div className="email">
          <FaEnvelope className="icon" /> <h3>ivy0925chen@gmail.com</h3>
        </div>
      </div>
      <div className="socials">
        <ul>
          <li>
            <a
              href="https://www.linkedin.com/in/ivy-chen-4065aab7/"
              target="_blank"
            >
              Linkedin
            </a>
          </li>
          <li>
            <a href="https://twitter.com/Ivavay" target="_blank">
              Twitter
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/wonderbar.studio/"
              target="_blank"
            >
              Instagram
            </a>
          </li>
          <li>
            <a href="https://github.com/ivavay" target="_blank">
              Github
            </a>
          </li>
        </ul>

        <div className="copyright">
          <h5>Made with React.js © Ivy Chen 2022</h5>
        </div>
      </div>
    </div>
  );
}
